import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "btn-toolbar justify-content-between",
  rowl: "toolbar"
}
const _hoisted_2 = {
  class: "btn-group",
  role: "group"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_testForm = _resolveComponent("testForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_testForm, {
      model: _ctx.model,
      schema: _ctx.schema,
      showModel: _ctx.showModel,
      formBox: _ctx.formBox,
      validators: _ctx.validators,
      redAst: "red",
      labelRed: "red",
      formSmallSize: "9",
      hintFontSize: "9",
      hintColor: "grey",
      hintFontStyle: "normal",
      onOpenFunc: _ctx.openFunc,
      ref: "formBox"
    }, null, 8 /* PROPS */, ["model", "schema", "showModel", "formBox", "validators", "onOpenFunc"]),
    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.checkModel()))
        }, "speichern")
      ])
    ])
  ]))
}